import { type FC, useEffect } from "react";
import { useAlert } from "../../contexts/AlertProvider";
import { useOrganization } from "../../contexts/OrganizationProvider";

export const Hagai: FC = () => {
    const { currOrganization } = useOrganization();
    const { setIsSidebarOpen } = useAlert();

    useEffect(() => {
        setIsSidebarOpen(false);
    }, []);

    return (
        <div style={{ width: "94%", height: "100%", backgroundColor: "white" }}>
            <iframe src={`https://sal.hagai.co/${currOrganization?.hagaiUsername}`} width="100%" height="100%" />
        </div>
    );
};